import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";
import { Box, Breadcrumbs, Button, Card, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import Pagination from "./Pagination";
import SearchTextField from "../../../../components/SearchTextField";

interface ProcessDefinitions {
  id: string;
  name: string;
  key: string;
  version: number;
  startable: boolean;
  suspended: boolean;
  resource: string;
  deploymentId: string;
  tenantId: string;
  category: string;
  description: string;
  isExecutavelPortalExterno: boolean;
}

interface CategorieProcess {
  category: string;
  processDefinitions: ProcessDefinitions[];
}

interface ProcessListProps {
  selectCategory: CategorieProcess;
  setCategory: (category: CategorieProcess | null) => void;
  navigateToHome?: () => void;
  navigate: (path: string) => void;
  tenantName?: string;
  isViewBreadcrumbs: boolean;
}

const ProcessList: React.FC<ProcessListProps> = ({
  selectCategory,
  setCategory,
  navigate,
  tenantName,
  navigateToHome,
  isViewBreadcrumbs,
}) => {
  const { t } = useTranslation();
  const [dataCategories, setDataCategories] = useState<ProcessDefinitions[]>(
    selectCategory.processDefinitions,
  );
  const [page, setPage] = useState(0);
  const itemsPerPage = 10;

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    const filtered = selectCategory.processDefinitions.filter((request) =>
      request.name.toLowerCase().includes(searchTerm),
    );
    setDataCategories(filtered);
  };

  return (
    <Box sx={{ width: "100%" }}>
      {isViewBreadcrumbs ? (
        <Box sx={{ padding: "0 16px", marginBottom: "16px" }}>
          <Breadcrumbs aria-label="breadcrumb" separator="›">
            <Typography
              color="inherit"
              key="0"
              onClick={() => navigateToHome?.()}
              sx={{ cursor: "pointer" }}
            >
              {t("common.catalog")}
            </Typography>
            {tenantName ? (
              <Typography
                color="inherit"
                key="1"
                onClick={() => {
                  setCategory(null);
                }}
                sx={{ cursor: "pointer" }}
              >
                {tenantName}
              </Typography>
            ) : null}
            <Typography />
          </Breadcrumbs>
          <Typography fontSize={20} fontWeight={500} variant="h6">
            {selectCategory.category === "Sem Categoria"
              ? t("home.others")
              : selectCategory.category}
          </Typography>
        </Box>
      ) : null}
      <SearchTextField
        handleSearch={handleSearch}
        placeholder={t("home.searchServicePlaceholder")}
        title={t("home.searchServiceTitle")}
      />
      {dataCategories
        .slice(page * itemsPerPage, (page + 1) * itemsPerPage)
        .map((process) => (
          <Card
            key={process.id}
            sx={{ padding: "18px 16px 0px 16px", marginBottom: "16px" }}
          >
            <Typography component="div" variant="h6">
              {process.name}
            </Typography>
            <Typography component="div" sx={{ padding: "8px 0" }}>
              {process.description}
            </Typography>
            <Button
              endIcon={<PlayCircleFilledIcon sx={{ color: "#ffffff" }} />}
              fullWidth
              onClick={() => {
                navigate(`first-registration/${process.id}`);
              }}
              sx={{ margin: "16px 0" }}
              variant="contained"
            >
              {t("home.startRequest")}
            </Button>
          </Card>
        ))}
      {dataCategories.length === 0 ? (
        <Box sx={{ textAlign: "center", padding: "16px" }}>
          <Typography color="text.secondary" variant="body1">
            {t("home.noService")}
          </Typography>
        </Box>
      ) : (
        <Pagination
          itemsPerPage={itemsPerPage}
          page={page}
          setPage={setPage}
          totalItems={selectCategory.processDefinitions.length}
        />
      )}
    </Box>
  );
};

export default ProcessList;
